import {FormControl, FormGroup, Validators} from "@angular/forms";
import {BulkOrderCountModel} from "./bulk-order-count.model";

function parseDateFromJSON(date) {
  if (!date) return "";
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return "";
  return matches[1] || "";
}

export interface AddAssetsDialogInputModel {
  deviceId?: string;
  siteId: string;
  maxQuantity: number;
  bulkOrderCounts: BulkOrderCountModel[];
}

export interface AddAssetsDialogModel {
  deviceId?: string;
  siteId: string;
  quantity: number;
  standaloneProductNumber?: string;
  product?: string;
  family?: string;
  model?: string;
  manufacturer?: string;
  building?: string;
  department?: string;
  floor?: string;
  floorMapId?: string;
  grid?: string;
  bulkOrderNumber?: any;
  orderDate?: string;
  orderNumber?: string;
  eotLeaseDate?: string;
}

export function addAssetsModelFactory(json?: any): AddAssetsDialogModel {
  json = json || {};

  return {
    deviceId: json.deviceId || undefined,
    siteId: json.siteId,
    quantity: json.quantity,
    standaloneProductNumber: json.standaloneProductNumber,
    product: json.product,
    family: json.family,
    model: json.model,
    manufacturer: json.manufacturer,
    building: json.building || undefined,
    department: json.department || undefined,
    floor: json.floor || undefined,
    floorMapId: ((json.quantity === 1) ? json.floorMapId || undefined : undefined),
    grid: ((json.quantity === 1) ? json.grid || undefined : undefined),
    orderDate: parseDateFromJSON(json.orderDate),
    orderNumber: json.orderNumber || undefined,
    eotLeaseDate: parseDateFromJSON(json.eotLeaseDate),
  };
}

const baseForm = {
  building: new FormControl(null, [Validators.maxLength(60)]),
  floor: new FormControl("", [Validators.maxLength(60)]),
  department: new FormControl("", [Validators.maxLength(60)]),
  bulkOrderNumber: new FormControl({}),
  eotLeaseDate: new FormControl(""),
  eotLeaseDatePicker: new FormControl(""), // This sucks
};

const createQuantityFormControl = (maxQuantity) => {
  const quantityValidations = [Validators.required];
  if (maxQuantity) {
    quantityValidations.push(Validators.max(maxQuantity));
  }
  return new FormControl(null, quantityValidations);
};

export function addAssetsWithDeviceFormGroup(maxQuantity): FormGroup {
  return new FormGroup({
    ...baseForm,
    quantity: createQuantityFormControl(maxQuantity),
    familyModel: new FormControl(null, [Validators.required]),
    floorMapId: new FormControl("", [Validators.maxLength(60)]),
    grid: new FormControl("", [Validators.maxLength(60)]),
  });
}

export function addAssetsStandaloneFormGroup(maxQuantity): FormGroup {
  return new FormGroup({
    ...baseForm,
    quantity: createQuantityFormControl(maxQuantity),
    standaloneProductNumber: new FormControl("", [Validators.required, Validators.maxLength(20)]),
  });
}
